import { buildJourneyFromStepIds } from '../pages/Journey/JourneyFlowItems';
import { getCardSides } from './helpers';
import { i18n } from '../i18n';

export function buildFeltMediatorPrompt({
  relationshipDataText,
  numberOfSuggestions = 3,
  existingSuggestions = [],
  shouldGenerateMirrorNameAndDescription = true,
  language = 'en'
}) {
  let prompt = '';

  const LANGUAGE_LABELS = {
    en: 'English',
    he: 'Hebrew',
    ar: 'Arabic'
  };
  const targetLanguageLabel = LANGUAGE_LABELS[language] || language;

  prompt += 'You are a friendly mediator app.\n';
  prompt += 'You are an expert in using professional principles from conflict resolution, therapy, mediation, Social emotional learning and education — including methods and frameworks such as Cognitive Behavioral Therapy (CBT), Nonviolent Communication (NVC), Social-Emotional Learning (SEL), Positive Psychology, Narrative Therapy, Conflict Resolution, Restorative Practices, Play Therapy, and Attachment Theory. Use concepts like emotional awareness, cognitive restructuring, behavior activation, communication skills, self-regulation, empathy building, co-regulation, perspective-taking, and validation.\n';
  prompt += 'This is a session between a user who is a young child and you.\n';
  prompt += 'The child just mirrored a relationship he has with someone else.\n';
  prompt += 'You are talking directly to the child.\n\n';

  prompt += 'Here is the relationship that the child just mirrored:\n';
  prompt += `${relationshipDataText}\n\n`;

  prompt += 'STEP 1: Identify Relationship Problems: \n';
  prompt += 'Look at the relationship story above and search for Problems in the Relationship \n';
  prompt += 'One of our main responsibilities here is to define between 3 types of problems, and so that children will get a clear understanding of what is right and what is wrong in a relationship, as some things might not be clear or obvious to them. \n';
  prompt += '"Not crossed the red line" - means that the child did or has experienced something that is (A) not putting either of them in risk, and (B) is also something that is not okay in a relationship, might be upsetting or difficult but are still normal parts of learning how to get along. Examples: not sharing, not listening, not respecting each other, not taking turns, not saying please and thank you.\n\n';
  prompt += '"Crossed the red line" - means that the child did or has experienced something that is (A) not putting either of them in risk, and (B) is something that is never okay in any relationship. Examples: hitting, kicking, pushing, scary yelling, name-calling, bullying, threats, or saying very mean things again and again.\n';
  prompt += '"Black alert" - means that the child did or has experienced something that is (A) IS putting either of them in risk, and (B) is something that thretens either of their physical or emotional safety - this is very serious urgent situation and needs to be addressed immediately. Examples: physical violence from adult/s, physical violence from other children that is very serious and needs to be addressed immediately, sexual abuse, strong emotional abuse, neglect, abandonment, devere depression, self-harm, suicide attempts, or other serious problems.\n\n';
  
  prompt += 'OUTPUT STEP 1: the Relationship Problems you found should be in this format:\n\n';
  prompt += 'output:';
  prompt += '- relationshipProblem-name: short name.\n';
  prompt += '- relationshipProblem-description: a few short lines about what problem this is.\n';
  prompt += '- relationshipProblem-type: "crossedTheRedLine" or "notCrossedTheRedLine".\n';
  
  prompt += 'If the relationship includes "black alert" problem/s, use these rules: — \n';
  prompt += 'wording: Use Trauma-informed copy, such as "No one deserves to be hurt", never "You should have...".\n';
  prompt += '- relationshipProblem-name: short name.\n';
  prompt += '- relationshipProblem-description: a few short lines about what problem this is.\n';
  prompt += '- relationshipProblem-blackAlert-informContactPerson: this will be sent to the child\'s contact person (parent or guardian), admins, etc. Write a **verbatim-style incident record** of what the child described. Do not shorten, do not summarize. Include every detail the child mentioned: names, places, actions, order of events, and feelings. Keep the language clear and trauma-informed (e.g., "No one deserves to be hurt"), but otherwise repeat the child’s words as fully as possible. Do not invent anything. The goal is a complete protocol-like log of exactly what the child shared.\n';
  prompt += '- relationshipProblem-type: "blackAlert".\n';
  prompt += 'To clarify: blackAlertInformContactPerson is only required if the type is "blackAlert". Otherwise, leave it out.\n';
  
  
  if (shouldGenerateMirrorNameAndDescription) {
    if (language !== 'en') {
      prompt += `Please respond ONLY in ${targetLanguageLabel}, including all following text:\n`;
    }
    
    prompt += 'STEP 2 & Output STEP 2: Situation name and description: \n';
    prompt += 'Situation name: Start by naming this situation in a very short name, use gentle wording fit for children language. \n';
    prompt += 'Situation description: Describe the situation, in a few sentences, again in a gentle way fit for children language. \n';
    prompt += 'Important: Do not mention "black alert" / "crossed the red line" / "not crossed the red line" in the situation name or description. \n';
  }

//   prompt += 'STEP 3: Alignment Summary\n';
//   prompt += 'For each side in the relationship, write a short summary (2–3 sentences, max 400 characters). \n';
//   prompt += 'The structure is: feeling → what happened → behavior that bothers this side → what this side needs. \n';
//   prompt += 'Write in third person, as if echoing back what they described, so they feel listened to. \n';
//   prompt += 'Keep it real: only include details the user provided, do not invent or assume anything if not mentioned. \n';
//   prompt += 'Write in third person, as if echoing back what they described, so they feel listened to. \n';
//   prompt += 'Keep it real: only include details the user provided, do not invent or assume anything if not mentioned. \n';
//   prompt += 'OUTPUT STEP 3: \n';
//   // we need to add this to the function calling
//   prompt += 'alignmentSummarySideA: summary of side A \n';
//   prompt += 'alignmentSummarySideB: summary of side B \n';
 
//   prompt += 'STEP 4: Alignment Summary Bubbles \n'
//   prompt += 'Write one short text-bubble style sentence for each side.  \n'
//   prompt += 'Rules: \n'
//   prompt += '1. Each side names one thing they don’t like in the relationship.  \n'
//   prompt += '2. Keep it short and simple (like kids talk).  \n'
//   prompt += '3. Use a personal tone ("I don’t like...").  \n'
//   prompt += '4. Add an emoji to show the feeling.  \n'
//   prompt += '5. Do not include deep or private thoughts — keep it light and safe.  \n'
  
//   prompt += 'OUTPUT STEP 4: \n'
//   // we need to add this to the function calling
//  prompt += 'alignmentSummaryBubbleSideA: "..."  \n'
//  prompt += 'alignmentSummaryBubbleSideB: "..." \n'
  
prompt += 'STEP 5: SidesSummaries\n';
  prompt += `To help the child, give ${numberOfSuggestions} \n`;

  if (existingSuggestions.length > 0) {
    prompt += `You have already suggested these ideas:\n${existingSuggestions.map(s => `- ${s.title}`).join('\n')}\n\n`;
    prompt += `Please give ${numberOfSuggestions} DIFFERENT ideas that you haven't suggested yet.\n\n`;
  }

  prompt += 'How to write a suggestion: ';
  prompt += 'Talk directly to the child. Make each idea very easy to understand and follow. Use very simple words.\n';
  prompt += "Sometimes the child will reflect a negative experience, sometime a positive one - in the later case, don't try to solve what isn't a problem.\n\n";

  prompt += 'Safety comes first: ';
  prompt += 'IMPORTANT: Before you suggest an idea, make sure the child is safe.\n';
  prompt += 'If the problem/s is/are "black alert" - suggest ideas for getting the child to safety, using trauma-informed language. example: "You are not supposed to go through this alone. Talk to a grown-up you trust. Your safety is the most important thing."\n\n';

  prompt += 'If the child is safe - continue to suggest ideas:';
  prompt += 'syggestion idea emoji: Write an emoji/s (up to 3) to help convey the suggestion. \n';
  prompt += 'suggestion idea: Write an idea as a gentle suggestion — things the child *can try*, not things the child *must do*. Avoid putting pressure on the child.\n\n, focus on what to do - not why to do - this will come later';
  prompt += 'suggestion title: The suggestion title should be a short summary of what to do (like "Say Thank You" or "Share Toys").\n';
  prompt += 'suggestion why: For the "why" part, explain to the child why this will help THEM. Use simple words.';

  if (language !== 'en') {
    prompt += `\nReminder: Please respond ONLY in ${targetLanguageLabel}, including all texts.`;
  }

  return prompt;
}

export async function callFeltMediator({
  prompt,
  numberOfSuggestions = 3,
  shouldGenerateMirrorNameAndDescription = true,
  fallbackPartnerName,
  functionDefinition: customFunctionDefinition
}) {
  const functionDefinition = customFunctionDefinition || {
    name: 'generate_relationship_suggestions',
    description: 'Generate actionable suggestions for improving a relationship based on the provided data',
    parameters: {
      type: 'object',
      properties: {
        relationshipProblems: {
          type: 'array',
          description: 'Relationship Problems found in the story'.trim(),
          items: {
            type: 'object',
            properties: {
              name: { type: 'string'},
              description: { type: 'string' },
              type: { type: 'string', enum: ['crossedTheRedLine', 'notCrossedTheRedLine', 'blackAlert'] },
              blackAlertInformContactPerson: { type: 'string' }
            },
            required: ['name', 'description', 'type']
          }
        },
        ...(shouldGenerateMirrorNameAndDescription
          ? {
              mirrorName: {
                type: 'string',
                description:
                  "A very short name for this conflict (max 20 characters, like 'Toy Fight' or 'Sharing Problem')"
              },
              mirrorDescription: {
                type: 'string',
                description:
                  "A brief reflective summary (2-3 sentences) that helps the child remember what happened between them and their friend. Describe the situation, what both kids went through, and help the child reflect on the experience. This should be thoughtful and help bring up the emotions and events they shared."
              }
            }
          : {}),
        suggestions: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              emoji: {
                type: 'string',
                description:
                  "An emoji/s (up to 3) to help convey the suggestion"
              },
              title: {
                type: 'string',
                description:
                  "A short summary of what to do (max 30 characters, like 'Say Thank You' or 'Share Toys')"
              },
              description: {
                type: 'string',
                description:
                  'A very simple explanation of what to do. Use very basic words that a 4-6 year old can understand.'
              },
              why: {
                type: 'string',
                description:
                  "Explain to the child why this might help them. Use very simple words like 'This will make your friend happy' or 'This helps you be a good friend' (max 50 characters)"
              }
            },
            required: ['emoji', 'title', 'description', 'why']
          },
          minItems: numberOfSuggestions,
          maxItems: numberOfSuggestions
        }
      },
      required: shouldGenerateMirrorNameAndDescription
        ? ['emoji', 'mirrorName', 'mirrorDescription', 'suggestions']
        : ['suggestions']
    }
  };

  try {
    const backendUrl = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BACKEND_URL)
      ? process.env.REACT_APP_BACKEND_URL
      : '';
    console.log('🛰️ callFeltMediator:start', {
      numberOfSuggestions,
      shouldGenerateMirrorNameAndDescription,
      promptLength: (prompt || '').length,
      promptPreview: (prompt || '').slice(0, 300),
      backendUrl,
      finalUrl: `${backendUrl}/api/mediator`
    });
    const token = localStorage.getItem('token');
    const response = await fetch(`${backendUrl}/api/mediator`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ prompt, functionDefinition, numberOfSuggestions })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('🛰️ callFeltMediator:response', data);
    if (data && typeof data === 'object' && data.relationshipProblems) {
      console.log('🔴🔴🔴 callFeltMediator:relationshipProblems', data.relationshipProblems);
    }
    return data;
  } catch (error) {
    console.error('Error calling AI mediator:', error);
    if (customFunctionDefinition) {
      throw error; // Let the caller handle specific function failures
    }
    return {
      mirrorName: 'Relationship Conflict',
      mirrorDescription:
        "You and your friend had a disagreement that made both of you feel upset. This situation helped you learn more about each other's feelings and needs.",
      suggestions: [
        {
          emoji: '👂',
          title: 'Practice Active Listening',
          description:
            fallbackPartnerName
              ? `When ${fallbackPartnerName} shares their feelings, try to listen without interrupting and repeat back what you heard. This shows you care about understanding their perspective and can help prevent misunderstandings.`
              : 'Listen without interrupting and repeat back what you heard. This shows you care and helps prevent misunderstandings.'
        },
        {
          emoji: '💬',
          title: "Use 'I' Statements",
          description:
            fallbackPartnerName
              ? `Share your feelings using "I" statements like "I feel [emotion] when [situation]" instead of blaming language. This avoids putting ${fallbackPartnerName} on the defensive and leads to better conversations.`
              : 'Share your feelings using "I" statements like "I feel [emotion] when [situation]" instead of blaming language.'
        },
        {
          emoji: '🤝',
          title: 'Find Common Ground',
          description:
            'Look for activities you both enjoy and spend time together. Shared experiences create positive memories and strengthen your bond.'
        }
      ]
    };
  }
}


export function buildRelationshipDataTextFromJourney({
  mirrorData,
  name,
  partnerName,
  side1Gender,
  side1Animal,
  side2Gender,
  side2Animal,
  relation
}) {
  try {
    const jp = mirrorData?.journeyProps || {};
    const journeyFlow = buildJourneyFromStepIds(mirrorData?.journeyStepIds || []);

    let message = '';
    // Header block (translated to current UI language)
    message += i18n.t('aiPrompt.header.intro') + `\n`;
    message += i18n.t('aiPrompt.header.userNameGender', { name, gender: side1Gender }) + `\n`;
    message += i18n.t('aiPrompt.header.userAnimal', { name, animal: side1Animal }) + `\n`;
    message += i18n.t('aiPrompt.header.side2', { partnerName, partnerGender: side2Gender }) + `\n`;
    message += i18n.t('aiPrompt.header.partnerAnimal', { name, partnerName, partnerAnimal: side2Animal }) + `\n`;
    message += i18n.t('aiPrompt.header.relation', { partnerName, relation, name }) + `\n\n`;

    // Walk dynamic flow
    journeyFlow.forEach((journeyItem) => {
      journeyItem?.steps?.forEach((step) => {
        const stepItems = Array.isArray(step?.stepItems) ? step.stepItems : [];
        stepItems.forEach((stepItem) => {
          if (!stepItem || stepItem.type === 'Intro') return;
          const stateKey = stepItem.state;
          const value = jp[stateKey];
          if (!value) return;

          switch (stepItem.type) {
            case 'TextArea': {
              const labelKey = stepItem.label || stateKey;
              const label = i18n.t(labelKey, { name, partnerName });
              message += `\n${label}:\n`;
              message += `${String(value)}\n`;
              break;
            }
            case 'FeelsCard': {
              const list = Array.isArray(value) ? value : [];
              if (list.length > 0) {
                const labelKey = stepItem.label || 'Feels';
                const label = i18n.t(labelKey, { name, partnerName });
                message += `\n${label}:\n`;
                list.forEach((card, idx) => {
                  const title = card?.content || i18n.t(`cards.FEEL.${card?.title}.title`);
                  const modifier = card?.modifier || '';
                  message += `${idx + 1}. ${title}${modifier ? ` (${modifier})` : ''}\n`;
                });
              }
              break;
            }
            case 'NeedCard': {
              const list = Array.isArray(value) ? value : [];
              if (list.length > 0) {
                const labelKey = stepItem.label || 'Needs';
                const label = i18n.t(labelKey, { name, partnerName });
                message += `\n${label}:\n`;
                list.forEach((card, idx) => {
                  const title = card?.content || i18n.t(`cards.NEED.${card?.title}.title`);
                  const modifier = card?.modifier || '';
                  message += `${idx + 1}. ${title}${modifier ? ` (${modifier})` : ''}\n`;
                });
              }
              break;
            }
            case 'HappenedCard': {
              const list = Array.isArray(value) ? value : [];
              if (list.length > 0) {
                const labelKey = stepItem.label || 'What happened';
                const label = i18n.t(labelKey, { name, partnerName });
                message += `\n${label}:\n`;
                list.forEach((card, idx) => {
                  const { sourceGender, targetName, sourceName } = getCardSides({
                    switchSides: card?.switchSides,
                    name,
                    partnerName,
                    gender: side1Gender,
                    partnerGender: side2Gender
                  });
                  const title = card?.content || i18n.t(`cards.HAPPENED.${card?.title}.title`, { context: sourceGender });
                  const modifier = card?.modifier || '';
                  message += `${idx + 1}. ${sourceName} → ${targetName}: ${title}${modifier ? ` (${modifier})` : ''}\n`;
                });
              }
              break;
            }
            default: {
              // For any other card-based step types that store arrays
              if (Array.isArray(value)) {
                const label = stepItem.label || stateKey;
                message += `\n${label}:\n`;
                value.forEach((item, idx) => {
                  const title = item?.content || item?.title || String(item);
                  message += `${idx + 1}. ${title}\n`;
                });
              }
            }
          }
        });
      });
    });

    return message;
  } catch (e) {
    console.error('buildRelationshipDataTextFromJourney failed', e);
    return '';
  }
}


